import sanitize from "../sanitize"
import { xssSanitize } from "../sanitize"

// replace all control characters which can get included when pasting from Word
const sanitiseInput = text  => {

  const sanitizedData = text
  .replace(/[\u0000-\u001F\u007F-\u009F\u2000-\u2008]/g, " ")
  .replace(/[\u2009-\u200f\ufeff\u2028]/g, "");

  return sanitize(sanitizedData)

}

// replace all control characters except new line
export const sanitiseInputAndPreventNewLine = text  => {

  const sanitizedData = text
  .replace(/[\u0000-\u0009\u000B-\u001F\u007F-\u009F\u2000-\u2008]/g, " ")
  .replace(/[\u2009-\u200f\ufeff\u2028]/g, "")

  return sanitize(sanitizedData)

}

export const xssSanitiseInputAndPreventNewLine = text  => {

  const sanitizedData = text
  .replace(/[\u0000-\u0009\u000B-\u001F\u007F-\u009F\u2000-\u2008]/g, " ")
  .replace(/[\u2009-\u200f\ufeff\u2028]/g, "")

  return xssSanitize(sanitizedData)

}

export default sanitiseInput
